<template>
  <div class="page">
    <pt-page-title title="批量订单"></pt-page-title>
    <router-link to="/order-new"><el-button type="primary">新建批量订单</el-button></router-link>
    <pt-lot-list-filter-form></pt-lot-list-filter-form>
  </div>
</template>

<script>
// 组件class前缀
import ptPageTitle from 'cps/base/pt-page-title'
import ptLotListFilterForm from 'cps/lab-order/pt-lot-list-filter-form'
const prefixCls = 'pt-lot-list'
export default {
  name: 'pt-lot-list',
  components: {
    ptPageTitle,
    ptLotListFilterForm
  },
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  methods: {

  }

}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.title{

}
</style>
